import { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { dateInDMY } from "../../Helpers";
import { SERVER_API } from "../../fileWithConstants";

const DupattaKaliList = () => {
  const [showModal, setShowModal] = useState(false);
  const [stockType, setStockType] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [qty, setQty] = useState("");
  const [remark, setRemark] = useState("");
  const [stockHistory, setStockHistory] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // FETCH DATA
  const getData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${SERVER_API}/api/v1/element/get-dupatta-kali-list`,
      );

      if (res.data.success) {
        setData(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure want to delete ?")) return;

    try {
      const res = await axios.delete(
        `${SERVER_API}/api/v1/element/delete-dupatta-kali/${id}`,
      );

      if (res.data.success) {
        toast.success(res.data.message);

        getData();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Delete failed");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const openStockModal = (item, type) => {
    setSelectedItem(item);
    setStockType(type);
    setQty("");
    setRemark("");
    setShowModal(true);
  };

  const saveStock = async () => {
    try {
      const { data } = await axios.post(
        `${SERVER_API}/api/v1/element/add-dupatta-kali-stock`,
        {
          el_id: selectedItem.id,
          qty,
          remark,
          transaction_type: stockType,
        },
      );

      if (data.success) {
        toast.success("Stock updated");
        setShowModal(false);
        getData();
      }
    } catch (error) {
      toast.error("Stock update failed");
    }
  };

  const viewStockDetails = async (item, type) => {
    try {
      const res = await axios.get(
        `${SERVER_API}/api/v1/element/dupatta-kali-stock-history/${item.id}/${type}`,
      );

      if (res.data.success) {
        setStockHistory(res.data.data);
        setStockType(type);
        setShowHistoryModal(true);
      }
    } catch (error) {
      toast.error("Failed to load stock history");
    }
  };

  return (
    <Layout title={"Dupatta/Kali List"}>
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Dupatta/Kali List</h4>

          <Link to="/dashboard/add-dupatta-kali" className="btn btn-primary">
            Add New
          </Link>
        </div>

        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              <th>Type</th>
              <th>Supplier</th>
              <th>Price/Pc</th>
              <th>Stock-In</th>
              <th>Stock-Out</th>
              <th>Available Stock</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center">
                  No Data Found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={item._id || item.id}>
                  <td>{index + 1}</td>

                  <td>
                    <a
                      href={`${SERVER_API}/uploads/elements/${item.image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`${SERVER_API}/uploads/elements/${item.image}`}
                        alt={item.name}
                        style={{
                          width: "30px",
                          objectFit: "cover",
                        }}
                      />
                    </a>
                  </td>

                  <td>{item.name}</td>

                  <td>{item.e_name}</td>
                  <td>{item.v_code}</td>

                  <td>{item.price}</td>

                  <td>
                    <span
                      style={{ cursor: "pointer", fontWeight: "bold" }}
                      onClick={() => viewStockDetails(item, 1)}
                    >
                      {item.stock_in}
                    </span>

                    <button
                      className="btn btn-sm btn-success ms-2"
                      onClick={() => openStockModal(item, 1)}
                    >
                      +In
                    </button>
                  </td>

                  <td>
                    <span
                      style={{ cursor: "pointer", fontWeight: "bold" }}
                      onClick={() => viewStockDetails(item, 2)}
                    >
                      {item.stock_out}
                    </span>

                    <button
                      className="btn btn-sm btn-danger ms-2"
                      onClick={() => openStockModal(item, 2)}
                    >
                      -Out
                    </button>
                  </td>
                  <td>{item.available_stock}</td>

                  <td>
                    <Link
                      to={`/dashboard/edit-dupatta-kali/${item._id || item.id}`}
                      className="btn btn-sm btn-warning me-2"
                    >
                      Edit
                    </Link>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(item._id || item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {showModal && (
          <div className="modal fade show d-block">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {stockType === 1 ? "Stock In" : "Stock Out"}
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label>Qty</label>
                    <input
                      type="number"
                      className="form-control"
                      value={qty}
                      onChange={(e) => setQty(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label>Remark</label>
                    <textarea
                      className="form-control"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button className="btn btn-primary" onClick={saveStock}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showHistoryModal && (
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {stockType === 1 ? "Stock In History" : "Stock Out History"}
                  </h5>

                  <button
                    className="btn-close"
                    onClick={() => setShowHistoryModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Date</th>
                        <th>Qty</th>
                        <th>Remark</th>
                      </tr>
                    </thead>

                    <tbody>
                      {stockHistory.length === 0 ? (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No Records
                          </td>
                        </tr>
                      ) : (
                        stockHistory.map((row, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{dateInDMY(row.created_at)}</td>
                            <td>{row.qty}</td>
                            <td>{row.remarks}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default DupattaKaliList;
